import type { HTMLAttributes, ReactNode } from "react";
import { injectCss } from "./injectCss";

const CSS = `
.js-tag{
  display:inline-flex;align-items:center;gap:6px;
  font-family:var(--font-sans);font-weight:var(--weight-semibold);font-size:var(--text-xs);
  padding:5px 10px;border-radius:var(--radius-sm);
  background:var(--neutral-100);color:var(--text-body);
  border:1px solid transparent;
}
.js-tag--outline{background:transparent;border-color:var(--border-default)}
.js-tag--brand{background:var(--brand-subtle);color:var(--teal-700)}
.js-tag__x{
  display:inline-flex;align-items:center;justify-content:center;
  width:15px;height:15px;border-radius:50%;border:none;background:transparent;
  color:inherit;cursor:pointer;opacity:.65;font-size:13px;line-height:1;padding:0;
  transition:opacity var(--dur-fast),background var(--dur-fast);
}
.js-tag__x:hover{opacity:1;background:rgba(0,0,0,.07)}
`;

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: "default" | "outline" | "brand";
  onRemove?: () => void;
  children?: ReactNode;
}

export function Tag({ tone = "default", onRemove, className = "", children, ...rest }: TagProps) {
  injectCss("js-tag-css", CSS);
  const cls = ["js-tag", tone !== "default" ? `js-tag--${tone}` : "", className].filter(Boolean).join(" ");
  return (
    <span className={cls} {...rest}>
      {children}
      {onRemove && (
        <button type="button" className="js-tag__x" aria-label="移除" onClick={onRemove}>
          ×
        </button>
      )}
    </span>
  );
}
